import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TimeoutInterceptorService, HTTP_GLOBAL_TIMEOUT_MS } from './timeout-interceptor.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptorService, multi: true },
    { provide: HTTP_GLOBAL_TIMEOUT_MS, useValue: 28000 }
  ]
})
export class TimeoutInterceptorModule {}


